import { auth, forgotPassword, recoverPassword } from '../apis/auth/auth';
import {
  clearUserTypeCookie,
  getUserTypeCookie,
  setUserTypeCookie,
} from '../shared/services/authUserTypeCookie';

let currentUserType: string | null = null;

export const LoginService = {
  login: async (email: string, password: string) => await auth({ email, password }),
  forgotPassword: async (email: string) => {
    await forgotPassword({ email })
      .then(() => undefined)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.detail ||
            'Nenhuma conta encontrada. Verifique o e-mail e tente novamente.',
        );
      });
  },
  recoverPassword: async (password: string, token: string) => {
    await recoverPassword({ password, token });
  },
  logout: () => {
    currentUserType = null;
    clearUserTypeCookie();
    localStorage.removeItem('token');
    localStorage.removeItem('token_date');
  },
  setUserType: (userType?: string | null) => {
    currentUserType = userType || null;
    setUserTypeCookie(currentUserType);
  },
  getUserType: () => {
    if (currentUserType) return currentUserType;
    const cookieUserType = getUserTypeCookie();
    currentUserType = cookieUserType;
    return cookieUserType;
  },
  isAuthenticated: () => {
    const isAuth =
      !!localStorage.getItem('token') &&
      !!localStorage.getItem('token_date') &&
      new Date().getTime() - parseInt(localStorage.getItem('token_date') || '0') <
        24 * 60 * 60 * 1000;

    if (!isAuth) {
      currentUserType = null;
      clearUserTypeCookie();
    }

    return isAuth;
  },
};
